/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import React, {Component} from 'react'
import classnames from 'classnames'
import {bool, func, node, number, string, oneOf} from 'prop-types'
import {IconArrowUpSolid, IconArrowDownLine} from '@instructure/ui-icons'

import {ScreenReaderContent} from '@instructure/ui-a11y-content'
import buildStyle from './style'

export default class StickyButton extends Component {
  static propTypes = {
    id: string.isRequired,
    children: node.isRequired,
    onClick: func,
    disabled: bool,
    hidden: bool,
    direction: oneOf(['none', 'up', 'down']),
    zIndex: number,
    buttonRef: func,
    description: string,
  }

  static defaultProps = {
    direction: 'none',
  }

  // @ts-expect-error TS7006 (typescriptify)
  constructor(props) {
    super(props)
    // @ts-expect-error TS2339 (typescriptify)
    this.style = buildStyle()
  }

  // @ts-expect-error TS7006 (typescriptify)
  handleClick = e => {
    // @ts-expect-error TS2339 (typescriptify)
    const {disabled, onClick} = this.props

    if (disabled) {
      e.preventDefault()
      e.stopPropagation()
    } else if (typeof onClick === 'function') {
      onClick(e)
    }
  }

  renderIcon() {
    // @ts-expect-error TS2339 (typescriptify)
    const direction = this.props.direction

    if (direction === 'up') {
      // @ts-expect-error TS2339 (typescriptify)
      return <IconArrowUpSolid className={this.style.classNames.icon} />
    } else if (direction === 'down') {
      // @ts-expect-error TS2339 (typescriptify)
      return <IconArrowDownLine className={this.style.classNames.icon} />
    } else {
      return null
    }
  }

  get descriptionId() {
    // @ts-expect-error TS2339 (typescriptify)
    return `${this.props.id}_desc`
  }

  renderDescription() {
    // @ts-expect-error TS2339 (typescriptify)
    if (this.props.description) {
      return (
        // @ts-expect-error TS2339 (typescriptify)
        <ScreenReaderContent id={this.descriptionId}>{this.props.description}</ScreenReaderContent>
      )
    }
    return null
  }

  render() {
    // @ts-expect-error TS2339 (typescriptify)
    const {id, children, disabled, hidden, direction, zIndex} = this.props

    const classes = {
      // @ts-expect-error TS2339 (typescriptify)
      [this.style.classNames.root]: true,
      // @ts-expect-error TS2339 (typescriptify)
      [this.style.classNames['direction--' + direction]]: direction !== 'none',
    }

    const style = {
      zIndex: zIndex || null,
    }

    return (
      <>
        {/* @ts-expect-error TS2339 (typescriptify) */}
        <style>{this.style.css}</style>
        <span>
          {/* @ts-expect-error TS2322 (typescriptify) */}
          <button
            id={id}
            type="button"
            onClick={this.handleClick}
            // @ts-expect-error TS2339 (typescriptify)
            className={classnames(classes, this.style.classNames.newActivityButton)}
            style={style}
            aria-disabled={disabled ? 'true' : null}
            aria-hidden={hidden ? 'true' : null}
            // @ts-expect-error TS2339 (typescriptify)
            ref={this.props.buttonRef}
            // @ts-expect-error TS2339 (typescriptify)
            aria-describedby={this.props.description ? this.descriptionId : null}
          >
            {/* @ts-expect-error TS2339 (typescriptify) */}
            <span className={this.style.classNames.layout}>
              {children}
              {this.renderIcon()}
            </span>
          </button>
          {this.renderDescription()}
        </span>
      </>
    )
  }
}
